import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Icon from '../components/AppIcon';
import { confirmPayment } from '../api/payments';

const FOREST = '#203B2D';
const FOREST_MUTED = '#4c594a';
const FOREST_SOFT = '#e8eee3';

export default function Merci() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState(token ? 'loading' : 'idle');
  const [kind, setKind] = useState(null);

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    (async () => {
      try {
        const res = await confirmPayment(token);
        if (cancelled) return;
        setKind(res?.data?.kind || 'payment');
        setStatus('success');
      } catch (e) {
        if (cancelled) return;
        console.error('Erreur confirmation paiement:', e);
        setStatus('error');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  const isClickCollect = kind === 'click-collect';

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center p-6"
      style={{ backgroundColor: '#f4f2ef' }}
    >
      <div
        className="w-full max-w-md rounded-2xl border bg-white p-8 sm:p-10 text-center shadow-sm space-y-4"
        style={{ borderColor: `${FOREST}33` }}
      >
        {status === 'loading' ? (
          <>
            <div
              className="mx-auto w-14 h-14 rounded-full flex items-center justify-center animate-pulse"
              style={{ backgroundColor: FOREST_SOFT, color: FOREST }}
            >
              <Icon name="Loader2" size={28} className="animate-spin" />
            </div>
            <p className="text-sm" style={{ color: FOREST_MUTED }}>
              Confirmation de votre paiement…
            </p>
          </>
        ) : null}

        {status === 'error' ? (
          <>
            <div
              className="mx-auto w-14 h-14 rounded-full flex items-center justify-center"
              style={{ backgroundColor: 'rgba(185, 28, 28, 0.1)', color: '#b91c1c' }}
            >
              <Icon name="AlertCircle" size={28} />
            </div>
            <h1 className="font-serif text-xl font-semibold" style={{ color: FOREST }}>
              Paiement non confirmé
            </h1>
            <p className="text-sm text-stone-600 leading-relaxed">
              Le paiement n&apos;a pas pu être validé. Si vous avez été débité, contactez le
              restaurant ou réessayez depuis votre e-mail de confirmation.
            </p>
          </>
        ) : null}

        {(status === 'success' || (status === 'idle' && !token)) ? (
          <>
            <div
              className="mx-auto w-14 h-14 rounded-full flex items-center justify-center"
              style={{ backgroundColor: FOREST_SOFT, color: FOREST }}
            >
              <Icon name="Check" size={28} strokeWidth={2.5} />
            </div>
            <h1 className="font-serif text-2xl font-semibold" style={{ color: FOREST }}>
              {isClickCollect ? 'Merci pour votre commande' : 'Merci pour votre achat'}
            </h1>
            <p className="text-sm leading-relaxed max-w-sm mx-auto" style={{ color: FOREST_MUTED }}>
              {isClickCollect
                ? 'Votre paiement est enregistré. Nous revenons vers vous rapidement pour confirmer votre retrait.'
                : 'Notre équipe revient vers vous rapidement.'}
            </p>
          </>
        ) : null}

        <p className="text-[11px] text-stone-500 pt-2">
          {status === 'success' ? 'Vous pouvez fermer cette page.' : null}
        </p>

        <Link
          to="/"
          className="inline-block text-sm font-medium underline-offset-2 hover:underline mt-2"
          style={{ color: FOREST }}
        >
          Retour à l&apos;accueil
        </Link>
      </div>
    </div>
  );
}
